import { Component, ViewChild } from '@angular/core';
import { Content, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the HelpPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */



@Component({
  selector: 'page-help',
  templateUrl: 'help.html',
})
export class HelpPage {
  @ViewChild(Content) private content: Content;
  helpImgs = ['help1.png','help2.png','help3.png','help4.png', 'help5.png', 'help6.png', 'help7.png', 'help8.png', 'help9.png', 'help10.png'];

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/help/help.ts